/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Link } from "react-router-dom";

import {FaAngleDown, FaAngleRight} from 'react-icons/fa';

const CollapseMenu = ({menu, icon, subMenu, toggled}) => {
    const [ show, setShow ] = useState(false);

    const clickAngle = (show) => {
        if(show){
            return <FaAngleDown className="collapsed-submenu btn-link d-md- d-md-positive "/>;
        }else{
            return <FaAngleRight className="collapsed-submenu btn-link d-md- d-md-positive "/>;
        }
    }
    return ( 
        <li className="nav-item">
            <a className={`nav-link ${show ? '': 'collapsed'} `} href="#" 
                aria-expanded="true" aria-controls="collapseUtilities" onClick={ ()=> {setShow(!show)} }>
                <i className="fas fa-fw fa-chart-area">{icon}</i>
                <span >{menu}</span> 
                {toggled ? 
                    null : 
                    clickAngle(show)
                }
                 
            </a>
            <div id="collapseUtilities" className={`collapse ${show ? 'show': ''}`} aria-labelledby="headingUtilities"
                data-parent="#accordionSidebar">
                <div className="bg-white py-2 collapse-inner rounded">
                    <h6 className="collapse-header">{`${menu}:`}</h6>
                    {subMenu.map(
                        (sub, i) => {
                            return (
                              <Link key={i} className="collapse-item" onClick={ ()=> {setShow(!show)} } to={sub.link}>{sub.nombre}</Link>  
                            )
                        }
                    )}
                    
                </div>
            </div>
        </li>      
     );
}
 
export default CollapseMenu;